<template>
    <base-modal
        mk="get-started-congratulations"
        :show.sync="modalOpen"
        :timer="2"
        :styles="modalStyles"
    >
        <div class="congratulations-modal-wrapper">
            <div class="content">
                <p class="title">Congratulations</p>
                <div class="desc">
                    <p class="msg1">You made it through all the steps with flying colors.</p>
                    <p class="msg2">You can continue booking shows in the booking manager.</p>
                </div>
            </div>
            <button @click="redirectToBooking" class="cta">Continue</button>
        </div>
    </base-modal>
</template>
<script>
    import axios from 'axios'
    import BaseModal from '@/composables/ui/useModal.js'
    import useNotification from '@/composables/useNotification.js'

    const URLS = {
        booking: {
            venue: '/booking-manager',
            artist: '/booking-manager/artist'
        },
        xhr: {
            fetch: {
                hideGetStarted: '/api/profile/hide-get-started'
            }
        }
    }

    export default {
        name: 'Congratulations',
        props: {
            status: {
                type: Number
            },
            profileRole: {
                type: String,
                validator: (v) => ['artist', 'venue'].includes(v)
            }
        },
        components: { BaseModal },
        setup() {
            const { notification } = useNotification()

            return {
                notification
            }
        },
        data: () => ({
            modalOpen: false,
            modalStyles: {
                modalWrapper: {
                    right: 'auto',
                    'overflow-y': 'hidden'
                }
            }
        }),
        watch: {
            status: function (status) {
                // status 5 => user completed get started
                if (status === 5) this.openModal()
            }
        },
        computed: {
            URLS: () => URLS
        },
        methods: {
            openModal() {
                this.modalOpen = true
            },
            async redirectToBooking() {
                try {
                    await axios.get(
                        `${this.URLS.xhr.fetch.hideGetStarted}/${this.profileRole}`
                    )
                    window.location.href =
                        this.profileRole === 'venue'
                            ? this.URLS.booking.venue
                            : this.URLS.booking.artist
                } catch (e) {
                    this.notification('error', e)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    $mobileMax: 600px;

    @media screen and (max-width: $mobileMax) {
        .congratulations-modal-wrapper {
            padding: 16px !important;
            background: none !important;

            .content {
                .title {
                    color: #dedede !important;
                    font-size: 26px !important;
                    line-height: 120% !important;
                    letter-spacing: -0.52px !important;
                }
            }
        }
    }

    .congratulations-modal-wrapper {
        max-width: 620px;
        min-width: 280px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 40px;
        padding: 48px 80px;
        background: #262626;
        border-radius: 16px;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        .content {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 12px;

            .title {
                color: #acacac;
                font-family: 'Instrument Sans';
                font-size: 38px;
                font-style: normal;
                font-weight: 500;
                line-height: 110%;
                letter-spacing: -0.76px;
            }
            .desc {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;

                .msg1,
                .msg2 {
                    color: #8b8b8b;
                    font-family: 'Instrument Sans';
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                }
            }
        }
        .cta {
            width: 100%;
            padding: 11px 30px 12px 30px;
            background: #cdeb09;
            border-radius: 100px;
            color: black;
            font-family: 'Instrument Sans';
            font-size: 18px;
            font-style: normal;
            font-weight: 550;
            line-height: 120%;
        }
    }
</style>
